import api from "../../../../../../service/api"

const rootUrl = 'tms/invoice/upload-documents'

export const getItem = (id = null) => api.get(`${rootUrl}/${id}`)

export const uploadItems = (id, data = null) => api.post(`${rootUrl}/${id}`, data)

export const deleteItem = (id) => api.delete(`${rootUrl}/${id}`)
